/** Block unsafe HTML in schedule e-communication email templates. */
export function validateEcommEmailHtml(html) {
  const s = String(html || "");
  if (!s.trim() || s === "<p><br></p>") {
    return { allowed: true };
  }

  const rules = [
    { test: /<script[\s>]/i, message: "Scripts are not allowed in email templates." },
    { test: /<style[\s>]/i, message: "Embedded styles are not allowed in email templates." },
    { test: /javascript\s*:|vbscript\s*:/i, message: "Script links are not allowed." },
    { test: /data\s*:[^"'\s>]+/i, message: "Embedded data (e.g. base64) is not allowed." },
    { test: /<img\b/i, message: "Images are not allowed in email templates." },
    { test: /<iframe\b|<object\b|<embed\b/i, message: "Embedded content is not allowed." },
    { test: /class="ql-code-block"/i, message: "Code blocks are not allowed in email templates." },
    { test: /\son[a-z]+\s*=/i, message: "Inline event handlers are not allowed." },
  ];

  for (const { test, message } of rules) {
    if (test.test(s)) {
      return { allowed: false, message };
    }
  }

  return { allowed: true };
}
